import CategoryPage from "./CategoryPage";

export default function CoLiving() {
  return (
    <CategoryPage
      categoryName="Co-living"
      categorySlug="co-living"
      categoryIcon="🏘️"
      categoryDescription="Modern shared living spaces and co-living communities in Rohtak"
    />
  );
}
